<template>
  <div v-if="max > 0" class="c-carousel"
    @touchstart="swipe"
    @touchend="swipe"
    @touchcancel="swipe"
  >
    <div class="c-carousel__slide">
      <div class="c-carousel__slideWrap">
        <div v-for="(photo, index) in params" ref="c-carousel__slidePhoto" class="c-carousel__slidePhoto" style="visibility: hidden;">
          <template v-if="photo.url">
            <a :href="photo.url"><img :src="photo.img" alt="" @load="imgloaded" /></a>
          </template>
          <template v-else>
            <img :src="photo.img" alt="" @load="imgloaded" />
          </template>
        </div>
      </div>

      <div v-show="max > 1" class="c-carousel__slidePrev" @click="changeCarousel('prev')">
        <span></span>
      </div>
      <div v-show="max > 1" class="c-carousel__slideNext" @click="changeCarousel('next')">
        <span></span>
      </div>
    </div>

    <div class="c-carousel__info">
      <ul :style="styleInfo" ref="c-carousel__info__ul">
        <li v-for="(photo, index) in params" ref="c-carousel__info__li">
          <template v-if="photo.url">
          <a v-if="photo.url" :href="photo.url"><p v-html="photo.caption"></p></a>
          </template>
          <template v-else>
          <p v-html="photo.caption"></p>
          </template>
        </li>
      </ul>
    </div>

    <div v-show="max > 1" class="c-carousel__seek">
      <ul>
        <li v-for="(photo, index) in params" :class="{'isSelected': index === current}"></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import { TweenMax, Cubic } from 'gsap/all';

  export default {
    data() {
      return {
        ispc: false,
        isStart: false,
        isTransition: true,
        assets_path: assets_path,
        styleInfo: '',
        direction: 1,
        params: [],
        max: 0,
        current: 0,
        next: 0,
        touchStartX: 0,
        touchMoveX: 0,
        touchStartTime: 0,
        autoTime: 6000,
        autoTimer: null,
        isAutoStart: true,
        slidePosY: 0,
        imgRatio: 16 / 9,
        preWidth: 0
      }
    },
    store,
    computed: {
    },
    created() {
    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-carousel').textContent);
      this.max = this.params.length;
      if (this.max > 0) {
        this.styleInfo = `width:${this.max * 100}%`;
        this.$nextTick(this.setting);
      }
    },
    methods: {
      setting() {
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.scroll);
        this.resize();
      },
      start() {
        this.isStart = true;
        TweenMax.set(this.$refs['c-carousel__slidePhoto'][this.current], {visibility: 'visible'});
        const slide = this.$refs['c-carousel__slidePhoto'][this.current].querySelector('img');

        TweenMax.fromTo(slide, 0.5,
          {
            x: '20%',
            opacity: 0,
            visibility: 'visible'
          },{
            x: '0%',
            opacity: 1,
            ease: Cubic.easeOut,
            onComplete: this.startComp
          });
      },
      startComp() {
        this.isTransition = false;
        if (this.max > 1 && this.isAutoStart) {
          this.autoTimer = setTimeout(this.changeCarousel.bind(this, 'next'), this.autoTime);
        }
      },
      changeCarousel(direction) {
        if (this.isTransition) return;
        this.isTransition = true;

        this.direction = (direction === 'prev') ? -1 : 1;
        this.next = this.getNext(direction);
        this.hideSlide();
      },
      slideCarousel() {
        this.hideSlide();
      },
      hideSlide() {
        const slide = this.$refs['c-carousel__slidePhoto'][this.current].querySelector('img');
        const info = this.$refs['c-carousel__info__li'][this.current];

        TweenMax.killTweensOf([slide, info]);

        TweenMax.to(slide, 0.4,
          {
            x: (-15 * this.direction) + '%',
            opacity: 0,
            ease: Cubic.easeIn,
            onComplete: this.hideSlideComp
          });

        TweenMax.to(info, 0.4,
          {
            opacity: 0,
            ease: Cubic.easeOut
          });
      },
      hideSlideComp(e) {
        TweenMax.set(this.$refs['c-carousel__slidePhoto'][this.current], {visibility: 'hidden'});
        TweenMax.set(this.$refs['c-carousel__info__li'][this.current], {visibility: 'hidden'});
        this.showSlide();
      },
      showSlide() {
        const slide = this.$refs['c-carousel__slidePhoto'][this.next].querySelector('img');
        const info = this.$refs['c-carousel__info__li'][this.next];

        TweenMax.killTweensOf([slide, info]);

        TweenMax.set(this.$refs['c-carousel__slidePhoto'][this.next], {visibility: 'visible'});

        TweenMax.fromTo(slide, 0.5,
          {
            x: (30 * this.direction) + '%',
            opacity: 0,
            visibility: 'visible'
          },{
            x: '0%',
            opacity: 1,
            ease: Cubic.easeOut,
            onComplete: this.showSlideComp
          });

        TweenMax.fromTo(info, 0.4,
          {
            x: -(this.next * 100) + '%',
            opacity: 0,
            visibility: 'visible'
          },
          {
            opacity: 1,
            ease: Cubic.easeOut
          });

        this.current = this.next;
        this.isTransition = false;
      },
      showSlideComp() {
        if (this.isAutoStart) {
          clearTimeout(this.autoTimer);
          this.autoTimer = setTimeout(this.changeCarousel.bind(this, 'next'), this.autoTime);
        }
      },
      swipe(e) {
        //e.preventDefault();
        if (this.$store.getters.isShowGnav) return;
        //if (this.isTransition) return;

        if (e.type === 'touchstart') {
          /** タッチ開始 */
          this.touchStartX = e.touches[0].pageX;
          this.touchStartTime = Date.now();

        } else if (e.type === 'touchend') {
          /** タッチ完了で状態を判定 */
          this.touchMoveX = e.changedTouches[0].pageX - this.touchStartX;

          let direction = '';
          if (this.touchMoveX > 0) {
            direction = 'prev';
          } else {
            direction = 'next';
          }

          if (Math.abs(this.touchMoveX) > 30 && Date.now() - this.touchStartTime <= 300) {
            // 遷移する
            this.changeCarousel(direction);
          } else if (Math.abs(this.touchMoveX) > (window.innerHeight / 2.5)) {
            // 遷移する
            this.changeCarousel(direction);
          }
        }
      },
      getNext(direction) {
        let next = 0;
        if (direction === 'prev') {
          next = this.current - 1;
          if (next < 0) next = this.max - 1;
        } else {
          next = (this.current + 1) % this.max;
        }
        return next;
      },
      scroll() {
        if (this.isStart) return;
        if (this.slidePosY < this.$_currentScrollY()) {
          this.start();
          this.reset();
        }
      },
      resize() {
        if (!this.isStart) {
          this.slidePosY = this.$_getOffsetTop(this.$el).top - (window.innerHeight * 0.9);
          this.scroll();
        }
      },
      reset() {
        window.removeEventListener('resize', this.resize);
        window.removeEventListener('scroll', this.scroll);
      },
      imgloaded(e) {
        const img = e.target;
        const ratio = img.naturalWidth / img.naturalHeight;

        if (this.imgRatio > ratio) {
          // 縦長
          img.style.height = '100%';
          img.style.width = 'auto';
        } else {
          // 横長
          img.style.height = 'auto';
          img.style.width = '100%';
        }
      }
    }
  }
</script>
